import { Address, CustomField } from "../../";
import { ClientType, ClientUserContactType } from "../../Clients";
import { Name, TableQueryFilter } from "../../common";
import {
	CommonServerStatusEnum,
	SyncData,
	VendorOpportunity
} from "../../index";
import { VendorPartner, VendorPartnerManager } from "../Partner";
import { VendorUserData } from "../User";

export interface VendorClientOpportunity {
	data: VendorOpportunity[];
}

export interface VendorClientUser {
	email: string;
}

export interface VendorClientUsers {
	data: VendorClientUser[];
}

export class VendorClient {
	id = "";
	name = "";
	created: Date;
	updated: Date;
	partner_companies: VendorPartner[];
	owner_user: VendorUserData;
	owner_user_id = "";
	sync_data: SyncData[] = new Array<SyncData>();
	vendor_opportunities: VendorClientOpportunity;
	vendor_client_users: VendorClientUsers;
	website = "";
	fax = "";
	facebook_url: string | null = null;
	twitter_url: string | null = null;
	linked_in_url: string | null = null;
	custom_fields?: CustomField[];
	partner_manager?: VendorPartnerManager;
	partner_ids: string[] = [];
	billing_address?: Address = new Address();
	shipping_addresses?: Address[] = new Array<Address>();
	company_type: ClientType | null = null;
	company_types: ClientType[] = new Array<ClientType>();
	constructor(
		id: string,
		name: string,
		partner_companies: VendorPartner[],
		owner_user: VendorUserData,
		sync_data: SyncData[] = new Array<SyncData>(),
		created: Date,
		updated: Date,
		vendor_opportunities: VendorClientOpportunity,
		vendor_client_users: VendorClientUsers,
		partner_manager?: VendorPartnerManager
	) {
		this.id = id;
		this.name = name;
		this.partner_companies = partner_companies;
		this.owner_user = owner_user;
		this.sync_data = sync_data;
		this.created = created;
		this.updated = updated;
		this.vendor_opportunities = vendor_opportunities;
		this.vendor_client_users = vendor_client_users;
		this.partner_manager = partner_manager;
	}
}

export class VendorClientContact {
	id = "";
	is_primary = false;
	phone? = "";
	email? = "";
	name: Name = new Name();
	contact_type: ClientUserContactType | null = null;
	vendor_client_company_id = "";
	vendor_client_company_name = "";
	mobile? = "";
	job_title? = "";
	department? = "";
	custom_fields?: CustomField[];
}
export class VendorClientContactRequest {
	filters: TableQueryFilter[] = new Array<TableQueryFilter>();
	limit = 50;
	page = 1;
	clientId = "";
	keywords?: string = "";
	selected_id?: string[] = [];
	countQueryFlag?: boolean = false;
	sortQuery?: string = "";
	localeQuery?: string = "";
	constructor(id: string) {
		this.clientId = id;
	}
}
export class VendorClientCount {
	all = 0;
}

export interface VendorClientContactCount extends VendorClientCount {}

export interface VendorClientContactResponse {
	data: VendorClientContact[];
	filtered_count_map?: VendorClientContactCount;
}

export class VendorClientResponse {
	data: VendorClient[] = new Array<VendorClient>();
	filtered_count_map: VendorClientCount | null = new VendorClientCount();
}

export class VendorClientEditOrAddRequest {
	name = "";
	partner_manager_id: string | null;
	owner_user_id: string | null;
	fax: string | null = null;
	website: string | null = null;
	linked_in_url: string | null = null;
	facebook_url: string | null = null;
	twitter_url: string | null = null;
	company_type: ClientType | null = null;
	billing_address: Address | null = null;
	custom_fields?: CustomField[] = new Array<CustomField>();

	constructor(formValues: VendorClientFormValues) {
		this.name = formValues.name;
		this.partner_manager_id = formValues.partner_manager_id ?? null;
		this.owner_user_id = formValues.owner_user_id;
		this.fax = formValues.fax;
		this.website = formValues.website;
		this.linked_in_url = formValues.linked_in_url;
		this.facebook_url = formValues.facebook_url;
		this.twitter_url = formValues.twitter_url;
		this.company_type = formValues.company_type;
	}
}

export class VendorClientFormValues {
	name = "";
	partner_manager_id?: string | null;
	owner_user_id = "";
	phone: string | null = null;
	country: string | null = null;
	state: string | null = null;
	city: string | null = null;
	street: string | null = null;
	pincode: string | null = null;
	fax = "";
	website = "";
	linked_in_url: string | null = null;
	facebook_url: string | null = null;
	twitter_url: string | null = null;
	company_type: ClientType | null = null;
	custom_field_form_values: Record<string, string> = {};
}
export interface VendorClientAddOrEditContactFormValues {
	first_name: string;
	last_name: string;
	email: string;
	phone: string;
	mobile: string;
	job_title: string;
	department: string;
	contact_type: ClientUserContactType;
	custom_field_form_values: Record<string, string>;
}
export interface VendorClientAddOrEditContactRequest {
	name: Name;
	email: string;
	phone: string;
	mobile: string;
	job_title: string;
	department: string;
	contact_type: ClientUserContactType;
	vendor_client_company_id: string;
	custom_fields?: Array<CustomField>;
}
export interface VendorClientContactBulkUpdate {
	id: string;
	entity: Omit<Partial<VendorClientContact>, "id">;
}

export interface VendorClientContactBulkUpdateRequest {
	data: VendorClientContactBulkUpdate[];
}
export interface VendorClientContactBulkUpdateResponse {
	status: CommonServerStatusEnum;
	response: VendorClientContact;
}

export interface VendorClientContactBulkUpdateServiceResponse {
	results: VendorClientContactBulkUpdateResponse[];
}
